<template>
  <div class="ladbrokes_card" :style="{
    backgroundImage: `url(${require('@/assets/background-image.svg')})`,
  }">
    <v-row class="p-0 m-0 custom-row">
      <v-col cols="9" align="center" class="white--text tableColumn" :style="{
        color: 'blue',
        fontSize: '16px',
        padding: '10px',
      }">
        <fixed-odd-bingo-flashboard :fontSize="fontSize" :playerView="true"
          :verifiedPanel="verifiedPanel"></fixed-odd-bingo-flashboard>
        <v-row class="lowerCards">
          <v-col align="center" class="white--text cardsFooter" :style="{
            color: 'blue',
            fontSize: '16px',
            padding: '3px 42px 1px 12px',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
          }">
            <!-- <v-row class=" logo-box"> -->
            <v-col cols="3" align="center" class="bingoLogoCard " :style="{ padding: '6px 6px 6px 0px' }">
              <div>
                <img :src="'data:image/png;base64,' + getGameLogo" alt="Game Logo" v-if="getGameLogo" />
              </div>
            </v-col>

            <v-col cols="3" align="center" class=" bingoLogoBoxNumber" :style="{ padding: '6px' }">
              <div>
                <span class="numberSpan">
                  Ordinal
                </span>
                <span class="ordinalSpanNumber">{{ getOrdinal }}</span>
              </div>
            </v-col>

            <v-col cols="3" align="center" class=" bingoLogoBoxNumber bingoGreyBox" :style="{ padding: '6px' }">
              <div>
                <span class="numberSpan">
                  Last Number
                </span>
                <span class="ordinalSpanNumber">
                  {{
                    getDrawnNumbers.length > 1
                      ? getDrawnNumbers[getDrawnNumbers.length - 2]
                      : 0
                  }}</span>
              </div>
            </v-col>

            <v-col cols="3" align="center" class=" bingoLogoBoxNumber" :style="{ padding: '6px' }">
              <div>
                <span class="numberSpan">
                  Number Called
                </span>
                <span class="ordinalSpanNumber">
                  {{
                    currentNumber !== "" &&
                      currentNumber !== null &&
                      currentNumber !== undefined
                      ? currentNumber
                      : getDrawnNumbers.length > 1
                        ? getDrawnNumbers[getDrawnNumbers.length - 1]
                        : 0
                  }}</span>
              </div>
            </v-col>

            <!-- </v-row> -->
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="3" class="white--text gapBox" :style="{
        color: 'blue',
        fontSize: '16px',
        padding: '10px 10px 0px 10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }">
        <div>
          <div v-if="getWinningPatternOneLine.length" class="one-line text-start ps-4 pt-3 pb-2">
            <div :class="[
              'oneLineSpan',
              {
                'disable-div':
                  isPatternExpired(getWinningPatternOneLine[0].intOne) ||
                  (Array.isArray(this.multipleWinners) &&
                    this.multipleWinners.includes('ONE_LINE')),
              },
            ]">
              One Line
            </div>

            <div>
              <div class="progressOneLine" v-if="
                !isPatternExpired(getWinningPatternOneLine[0].intOne) &&
                !(
                  Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('ONE_LINE')
                )
              ">
                <div class="barOneLine" :style="{
                  width:
                    getWinningPatternOneLine.length && getDrawnNumbers.length
                      ? Math.min(
                        (getDrawnNumbers.length * 100) /
                        getWinningPatternOneLine[0].intOne,
                        100
                      ) + '%'
                      : '0%',
                }"></div>
              </div>
              <div v-for="item in getWinningPatternOneLine" :key="item.id">
                <div class="oneLinediv mt-3" :class="{
                  'disable-div':
                    isPatternExpired(getWinningPatternOneLine[0].intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('ONE_LINE')),
                }">
                  €{{ item.intTwo }}
                </div>
                <img :src="isPatternExpired(item.intOne) ||
                  (Array.isArray(multipleWinners) &&
                    multipleWinners.includes('ONE_LINE'))
                  ? require('../../assets/disable.svg')
                  : require('../../assets/Maskgroup.svg')
                  " alt="Description of image" class="absolute-center-right" />
                <span class="absolute-center-right-number" :class="{
                  'disable-div':
                    isPatternExpired(item.intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('ONE_LINE')),
                }">{{ item.intOne }}</span>
              </div>
            </div>
          </div>
          <div v-else class="one-line text-start ps-4 pt-3 pb-2">
            <div class="">
              <div class="oneLineSpan mt-3 disable-div">One Line</div>
              <div class="oneLinediv mt-6 disable-div">€00</div>
            </div>
            <div>
              <img src="../../assets/disable.svg" alt="Description of image" class="absolute-center-right" />
              <span class="absolute-center-right-number disable-div">00</span>
            </div>
          </div>
        </div>
        <div>
          <div v-if="getWinningPatternTwoLine.length" class="one-line text-start ps-4 pt-3 pb-2">
            <div class="oneLineSpan" :class="{
              'disable-div':
                isPatternExpired(getWinningPatternTwoLine[0].intOne) ||
                (Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('TWO_LINE')),
            }">
              Two Line
            </div>
            <div>
              <div class="progressOneLine" v-if="
                !isPatternExpired(getWinningPatternTwoLine[0].intOne) &&
                !(
                  Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('TWO_LINE')
                )
              ">
                <div class="barTwoLine" :style="{
                  width:
                    getWinningPatternTwoLine.length && getDrawnNumbers.length
                      ? Math.min(
                        (getDrawnNumbers.length * 100) /
                        getWinningPatternTwoLine[0].intOne,
                        100
                      ) + '%'
                      : '0%',
                }"></div>
              </div>
              <div v-for="item in getWinningPatternTwoLine" :key="item.id">
                <div class="oneLinediv mt-3" :class="{
                  'disable-div':
                    isPatternExpired(item.intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('TWO_LINE')),
                }">
                  €{{ item.intTwo }}
                </div>
                <img :src="isPatternExpired(item.intOne) ||
                  (Array.isArray(multipleWinners) &&
                    multipleWinners.includes('TWO_LINE'))
                  ? require('../../assets/disable.svg')
                  : require('../../assets/Mask group blue.svg')
                  " alt="Description of image" class="absolute-center-right" />
                <span class="absolute-center-right-number" :class="{
                  'disable-div':
                    isPatternExpired(item.intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('TWO_LINE')),
                }">{{ item.intOne }}</span>
              </div>
            </div>
          </div>
          <div v-else class="one-line text-start ps-4 pt-3 pb-2">
            <div class="">
              <div class="oneLineSpan mt-3 disable-div">Two Line</div>
              <div class="oneLinediv mt-6 disable-div">€00</div>
            </div>
            <div>
              <img src="../../assets/disable.svg" alt="Description of image" class="absolute-center-right" />
              <span class="absolute-center-right-number disable-div">00</span>
            </div>
          </div>
        </div>
        <div>
          <div v-if="getWinningPatternFullHouse.length" class="one-line text-start ps-4 pt-3 pb-2">
            <div class="oneLineSpan" :class="{
              'disable-div':
                isPatternExpired(getWinningPatternFullHouse[0].intOne) ||
                (Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('FULL_HOUSE')),
            }">
              Full House
            </div>
            <div>
              <div class="progressOneLine" v-if="
                !isPatternExpired(getWinningPatternFullHouse[0].intOne) &&
                !(
                  Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('FULL_HOUSE')
                )
              ">
                <div class="barThreeLine" :style="{
                  width:
                    getWinningPatternFullHouse.length &&
                      getDrawnNumbers.length
                      ? Math.min(
                        (getDrawnNumbers.length * 100) /
                        getWinningPatternFullHouse[0].intOne,
                        100
                      ) + '%'
                      : '0%',
                }"></div>
              </div>
              <div v-for="item in getWinningPatternFullHouse" :key="item.id">
                <div class="oneLinediv mt-3" :class="{
                  'disable-div':
                    isPatternExpired(item.intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('FULL_HOUSE')),
                }">
                  €{{ item.intTwo }}
                </div>
                <img :src="isPatternExpired(item.intOne) ||
                  (Array.isArray(multipleWinners) &&
                    multipleWinners.includes('FULL_HOUSE'))
                  ? require('../../assets/disable.svg')
                  : require('../../assets/Mask group green.svg')
                  " alt="Description of image" class="absolute-center-right" />
                <span class="absolute-center-right-number" :class="{
                  'disable-div':
                    isPatternExpired(item.intOne) ||
                    (Array.isArray(multipleWinners) &&
                      multipleWinners.includes('FULL_HOUSE')),
                }">{{ item.intOne }}</span>
              </div>
            </div>
          </div>
          <div v-else class="one-line text-start ps-4 pt-3 pb-2">
            <div class="">
              <div class="oneLineSpan mt-3 disable-div">Full House</div>
              <div class="oneLinediv mt-6 disable-div">€00</div>
            </div>
            <div>
              <img src="../../assets/disable.svg" alt="Description of image" class="absolute-center-right" />
              <span class="absolute-center-right-number disable-div">00</span>
            </div>
          </div>
        </div>
        <div align="center" class="" :style="{
          color: 'blue',
          fontSize: '16px',
        }">
          <v-col v-if="getWinningPatternJackpot.length" align="center" class="one-line text-start ps-4 pt-3 pb-2">
            <div class="oneLineSpan" :class="{
              'disable-div':
                isPatternExpired(getWinningPatternJackpot[0].intOne) ||
                (Array.isArray(this.multipleWinners) &&
                  this.multipleWinners.includes('JACKPOT')),
            }">
              JACKPOT
              <img src="../../assets/coin.svg" alt="Description of image" class="ms-3 coin-width" />
            </div>
            <div class="progressOneLineJackpot" v-if="
              !isPatternExpired(getWinningPatternJackpot[0].intOne) &&
              !(
                Array.isArray(this.multipleWinners) &&
                this.multipleWinners.includes('JACKPOT')
              )
            ">
              <div class="barTwoLineJackpot" :style="{
                width:
                  getWinningPatternJackpot.length && getDrawnNumbers.length
                    ? Math.min(
                      (getDrawnNumbers.length * 100) /
                      getWinningPatternJackpot[0].intOne,
                      100
                    ) + '%'
                    : '0%',
              }"></div>
            </div>
            <div v-for="item in getWinningPatternJackpot" :key="item.id">
              <div class="oneLinediv " :class="{
                'disable-div':
                  isPatternExpired(item.intOne) ||
                  (Array.isArray(multipleWinners) &&
                    multipleWinners.includes('JACKPOT')),
              }">
                €{{ item.intTwo }}
              </div>
              <img :src="isPatternExpired(item.intOne) ||
                (Array.isArray(multipleWinners) &&
                  multipleWinners.includes('JACKPOT'))
                ? require('../../assets/disable.svg')
                : require('../../assets/jackpot-circle.svg')
                " alt="Description of image" class="absolute-center-right-jackpot" />
              <span class="absolute-center-right-number-jackpot" :class="{
                'disable-div':
                  isPatternExpired(item.intOne) ||
                  (Array.isArray(multipleWinners) &&
                    multipleWinners.includes('JACKPOT')),
              }">{{ item.intOne }}</span>
            </div>
          </v-col>

          <v-col v-else align="center" class="one-line text-start ps-4 pt-3 pb-2">
            <div>
              <div class="">
                <div class=" oneLineSpan mt-3 disable-div">JACKPOT</div>
                <div class="oneLinediv mt-6 disable-div">€00</div>
              </div>
              <div>
                <img src="../../assets/disable.svg" alt="Description of image" class="absolute-center-right" />
                <span class="absolute-center-right-number disable-div">00</span>
              </div>
            </div>
          </v-col>
        </div>

        <div class="ticketCard">
          <h1 class="ticketTitle">Ticket Color</h1>
          <div class="colorBox" :style="{ backgroundColor: getGameColours.attributeValue }">
            <h2 class="colorTitle">
              {{ getGameColours.attributeName }}
            </h2>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="showPauseModal" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          Game Paused
        </v-card-title>
        <v-card-text class="text-center pt-4">
          <div class="text-h6 mb-4">
            The game will resume shortly. Stay ready!
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="endGameModal">
      <v-dialog v-model="showEndGameModal" persistent>
        <v-card class="successModal">
          <v-card-text class="text-center pt-4" :style="{ position: 'relative' }">
            <img src="../../assets/sucess.svg" alt="Jackpot Image" class="successImg" />
            <div class="text-h6-end">
              Game Over<br />
              Thank You For Playing
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import { socketURL } from "@/api/clients/bingoManager-core/baseClient.js";
import Utils from "@/utils";
import FixedOddBingoFlashboard from "../../components/game/FixedOddBingoFlashboard.vue";
import {
  speakNumber,
  speakGameEnd,
  speakWinner,
  speakGamePattern,
  speakGameStart,
  speakTemplateEnd,
  parseTemplateStart,
} from "../../utils/speakNumber";

export default {
  name: "Player",
  components: {
    FixedOddBingoFlashboard,
  },
  data() {
    return {
      currentGame: null,
      currentNumber: "",
      connected: false,
      verifiedPanel: null,
      advertisingMessage: "",
      activePattern: 0,
      gameOrder: 1,
      showEndGameModal: false,
      multipleWinners: null,
      showPauseModal: false,
    };
  },
  methods: {
    ...mapActions([
      "setCurrentPattern",
      "startSchedule",
      "addCalledNumber",
      "fetchStatus",
      "setShowVerificationBoard",
      "updateNextGameForPlayer",
      "recalledNumber",
      "getSelectedSchedule",
    ]),
    isPatternExpired(intOne) {
      return intOne && this.getOrdinal > intOne;
    },
    textColour() {
      return Utils.getContrast(this.getGameColours.attributeValue);
    },
    connect() {
      this.socket = new SockJS(socketURL + "play");
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.connect(
        {},
        () => {
          this.connected = true;
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/call",
            (tick) => {
              this.parseCallMessage(JSON.parse(tick.body));
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/recall",
            (tick) => {
              this.parseRecallMessage(JSON.parse(tick.body));
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/verified",
            (tick) => {
              this.parseVerifiedMessage(JSON.parse(tick.body));
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/nextPattern",
            (tick) => {
              this.parseNextPatternMessage(JSON.parse(tick.body));
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/nextGame",
            (tick) => {
              this.parseNextGameMessage(JSON.parse(tick.body));
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/advertUpdate",
            (tick) => {
              this.parseAdMessage(JSON.parse(tick.body));
            }
          );
            this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/startGame",
            () => {
              this.parseStartGame();
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/endGame",
            () => {
              this.parseEndgame();
            }
          ); 
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/templateEnd",
            () => {
              this.parseTemplateEnd();
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/templateStart",
            () => {
              this.parseTemplateStart();
            }
          );
          this.stompClient.subscribe(
            "/topic/" + this.$route.params.scheduleId + "/pauseGameState",
            (tick) => {
              this.parsePauseMessage(JSON.parse(tick.body));
            }
          );
        },
        (error) => {
          console.log(error);
          this.connected = false;
        }
      );
    },
    getImgUrl(pic) {
      return require("../../assets/" + pic);
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
      this.connected = false;
    },
    tickleConnection() {
      this.connected ? this.disconnect() : this.connect();
    },
    async parseCallMessage(message) {
      this.currentNumber = message.drawnNumber;
      this.addCalledNumber(this.currentNumber);
      await speakNumber(this.currentNumber);
      this.setShowVerificationBoard(false);
    },
    parsePauseMessage(message) {
      this.showPauseModal = Boolean(message);
    },
    parseRecallMessage(message) {
      this.currentNumber = message.drawnNumber;
      this.recalledNumber(this.currentNumber);
      this.setShowVerificationBoard(false);
    },
    parseVerifiedMessage(message) {
      this.setShowVerificationBoard(false);
      speakWinner(message.winningPattern);
      this.verifiedPanel = message.panelId;
      this.setShowVerificationBoard(true);
      if (!Array.isArray(this.multipleWinners)) {
        this.multipleWinners = [];
      }

      if (!this.multipleWinners.includes(message.winningPattern)) {
        this.multipleWinners.push(message.winningPattern);
      }
      setTimeout(() => {
        this.setShowVerificationBoard(false);
      }, 10000);
    },
    parseNextPatternMessage(message) {
      speakGamePattern(message.newPattern);
      this.setShowVerificationBoard(false);
      if (message.newPattern == "ONE_LINE") {
        this.activePattern = 0;
        this.setCurrentPattern(0);
      } else if (message.newPattern == "TWO_LINE") {
        this.activePattern = 1;
        this.setCurrentPattern(1);
      } else if (message.newPattern == "FULL_HOUSE") {
        this.activePattern = 2;
        this.setCurrentPattern(2);
      }
    },
    parseNextGameMessage(message) {
      this.showEndGameModal = false;
      this.currentNumber = "0";
      this.updateNextGameForPlayer(message);
      this.activePattern = 0;
      this.gameOrder++;
      this.multipleWinners = [];
    },
    async parseStartGame() {
      speakGameStart();
    },
    async parseEndgame() {
      this.setShowVerificationBoard(false);
      this.showEndGameModal = true;
      this.showPauseModal = false;
      speakGameEnd();
    }, 
    async parseTemplateEnd() {
      this.setShowVerificationBoard(false);
      this.showEndGameModal = false;
      this.showPauseModal = false;
      speakTemplateEnd(); 
    },
    async parseTemplateStart() {
      this.setShowVerificationBoard(false);
      this.showEndGameModal = false;
      this.showPauseModal = false;
      parseTemplateStart();
    },
    parseAdMessage(message) {
      this.advertisingMessage = message.adMessage;
    },
  },
  computed: {
    ...mapGetters([
      "getOrdinal",
      "getActiveGame",
      "getSettingUpGame",
      "getAdMessage",
      "getDrawnNumbers",
      "getTenantId",
      "getScheduleList",
      "getGameStatus",
      "isPaused",
      "getGameLogo",
      "getGameColours",
      "getWinningPatterns"
    ]),

    isGamePaused() {
      return this.getGameStatus === "PAUSED";
    },
    getWinningPatternOneLine() {
      if (
        this.getWinningPatterns != null
      ) {
        return this.getWinningPatterns
          .filter(
            (winningPattern) => winningPattern.winningPattern == "ONE_LINE"
          )
          .sort((a, b) => a.intOne - b.intOne);
      } else {
        return [];
      }
    },
    getWinningPatternTwoLine() {
      if (
        this.getWinningPatterns != null
      ) {
        return this.getWinningPatterns
          .filter(
            (winningPattern) => winningPattern.winningPattern == "TWO_LINE"
          )
          .sort((a, b) => a.intOne - b.intOne);
      } else {
        return [];
      }
    },
    getWinningPatternFullHouse() {
      if (
        this.getWinningPatterns != null
      ) {
        return this.getWinningPatterns
          .filter(
            (winningPattern) => winningPattern.winningPattern == "FULL_HOUSE"
          )
          .sort((a, b) => a.intOne - b.intOne);
      } else {
        return [];
      }
    },
    getWinningPatternJackpot() {
      if (
        this.getWinningPatterns != null
      ) {
        return this.getWinningPatterns.filter(
          (winningPattern) => winningPattern.winningPattern == "JACKPOT"
        );
      } else {
        return [];
      }
    },
    selectedSchedule() {
      return this.getScheduleList.find(
        (schedule) => schedule.id == this.$route.params.scheduleId
      );
    },
    adMessage() {
      return this.advertisingMessage
        ? this.advertisingMessage
        : this.getAdMessage;
    },
    currentPattern() {
      if (!this.getActiveGame) {
        return "";
      }
      let winningPatternEnum = this.getActiveGame.winningPatterns[
        this.activePattern
      ];
      if (winningPatternEnum == "ONE_LINE") {
        return "Single Line";
      } else if (winningPatternEnum == "TWO_LINE") {
        return "Double Line";
      } else if (winningPatternEnum == "FULL_HOUSE") {
        return "Full House";
      }
      return "Bingo";
    },
    gameColour() {
      return this.getActiveGame && this.getActiveGame.colour
        ? this.getActiveGame.colour.attributeValue
        : null;
    },
    fontSize() {
      return `25px`;
    },
  },
  watch: {
    getGameStatus(newStatus) {
      this.showPauseModal = newStatus === "PAUSED";
    }
  },
  mounted() {
    let scheduleId = this.$route.params.scheduleId;
    this.fetchStatus(scheduleId);
    this.connect();
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Arial Rounded MT Bold";
  src: url("../../assets//fonts/arialroundedmtbold.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.logo-box {
  padding: 10px;
  min-height: 32vh;
}

.pattern {
  color: white;
  /* Chrome & Safari */
  -webkit-text-stroke: 1px #000;

  /* Firefox Fallback */
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}

.image_parent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: -15px;
}

.bonus_pot {
  background-image: url("../../assets/money_ball.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: contain;
  height: 100%;
}

.jackpot_1 {
  background-image: url("../../assets/jackpot_1-01.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: contain;
  height: 50%;
}

.jackpot_2 {
  background-image: url("../../assets/jackpot_2-01.png");
  background-repeat: no-repeat;
  background-position: left;
  background-size: contain;
  height: 50%;
}

.lastNumber {
  background-image: url("../../assets/last_number.png");
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
}

.advertMessage {
  font-weight: 600;
  border-radius: 2px;
  font-size: 35px;
  border-style: solid;
  border-width: 2px;
  text-align: center;
}

.bingoLogoBox {
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  /* min-height: 30vh; */
  max-width: 24%;
}

.bingoLogoBox img,
.bingoLogoCard img {
  width: 155px;
}

.bingoLogoBoxNumber {
  background-image: url("../../assets/goldcard.png");
  background-position: cover;
  background-position: center;
  background-repeat: no-repeat;
  backdrop-filter: blur(-50.266666412353516px);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  border-radius: 14px;
  background-size: cover;
  min-height: 190px;
  max-height: 190px;
  position: relative;
}

.bingoGreyBox {
  background-image: url("../../assets/greycard.png") !important;
}

.numberSpan {
  text-align: start;
  position: absolute;
  left: 10px;
  color: #fff;
  font-family: "Arial Rounded MT Bold";
  font-size: 24px;
  max-width: 80px;
}

.ordinalSpanNumber {
  text-align: end;
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: #fff;
  font-family: "Arial Rounded MT Bold";
  font-size: 80px;
}

.bingoLogoBox-ordinal {
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 65px;
  position: relative;
  height: 100%;
  max-width: 24%;
}

.absolute-bottom-center {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.one-line {
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  position: relative;
  min-height: 19vh;
  max-height: 19vh;
}

.one-line-jackpot {
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  position: relative;
  padding: 19px !important;
  min-height: 19vh;
  max-height: 19vh;
  max-width: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.oneLineSpan {
  color: #fff;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
}

.disable-div-jackpot {
  color: rgba(255, 255, 255, 0.38) !important;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 400;
}

.oneLineSpanJackpot {
  color: #fff;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.oneLinediv {
  color: #efa602;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
}

.disable-div-number-jackpot {
  color: rgba(255, 255, 255, 0.38) !important;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 35px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
}

.oneLinedivJackpot {
  color: #efa602;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
}

.progressOneLine {
  width: 70%;
  height: 9px;
  background: #a8a8a8;
  border-radius: 6px;
  margin-top: 12px;
}

.progressOneLineJackpot {
  width: 70%;
  height: 9px;
  background: #a8a8a8;
  border-radius: 6px;
  margin-top: 12px;
}

.barOneLine {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  border-radius: 6px;
  background: #990707;
}

.barTwoLine {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  border-radius: 6px;
  background: #0729a0;
}

.barTwoLineJackpot {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  border-radius: 6px;
  background: #efa602;
}

.barThreeLine {
  position: relative;
  float: left;
  min-width: 1%;
  height: 100%;
  border-radius: 6px;
  background: #207818;
}

.absolute-center-right {
  position: absolute;
  top: 50%;
  right: 0;
  width: 73px;
  transform: translateY(-50%);
}

.absolute-center-right-jackpot {
  position: absolute;
  top: 50%;
  right: 0;
  width: 72px;
  transform: translateY(-50%);
}

.absolute-center-top {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 139px;
}

.absolute-center-right-number {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
  color: #fff;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
}

.absolute-center-right-number-jackpot {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #fff;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
}

.ordinal-span {
  color: #fff;
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.ordinal-span-number {
  color: #fff;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Arial Rounded MT Bold", Arial, sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 400;
  z-index: 11111;
}

.value-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  z-index: 9999;
  gap: 22px;
}

.disable-div {
  color: rgba(255, 255, 255, 0.38) !important;
}

.ladbrokes_card {
  background-image: url(/img/background-image.068b2b5e.svg);
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  min-height: 100vh;
  padding: 12px 5px 1px 5px !important;
}

.successModal {
  border-radius: 39px !important;
  background: rgba(255, 255, 255, 0.1) !important;
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset !important;
  backdrop-filter: blur(50.266666412353516px) !important;
  color: rgba(0, 0, 0, 0.87);
  height: 245px;
  position: relative;
}

.successImg {
  position: absolute;
  top: -75px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 160px;
}

.text-h6-end {
  color: #fff;
  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 45px;
  font-style: normal;
  font-weight: 400;
  line-height: 59px;
  padding-top: 80px;
}

.endGameModal .v-dialog {
  max-width: 500px !important;
}

.coin-width {
  width: 40px;
}

.custom-row {
  margin: 0px 0px 10px 0px !important;
}

.ticketCard {
  margin-top: 10px;
  border-radius: 14px;
  background: #44413d;
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  height: 187px;
  flex-shrink: 0;
  padding: 20px;
  color: #fff;
  text-shadow: 1px 1px 30.6px rgba(0, 0, 0, 0.46);
  font-family: "Arial Rounded MT Bold";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.gapBox {
  gap: 10px;
}

.ticketTitle {
  font-size: 32px;
}

.colorTitle {
  font-size: 32px;
}

.colorBox {
  margin-top: 4px;
  /* width: 246px; */
  border-radius: 16px;

  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 18px;
  padding: 20px 10px;
}

.tableColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.lowerCards {
  margin-top: 10px;
  flex-shrink: 0;
  max-height: 200px;
}

.bingoLogoCard {
  border-radius: 14px;
  background-color: #44413d;
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  width: 466px;
  height: 187px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1024px) {
  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
  }

  .progressOneLine {
    width: 60%;
    height: 9px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 20px;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 70px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 7px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
  }

  .bingoLogoBox img {
    width: 100px;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 160px;
    transform: translateX(-50%);
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
  }

  /* .absolute-center-top {
    position: absolute;
    top: 50%;
    right: 0;
    width: 105px;
    transform: translateY(-50%);
  } */

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 20px 14px 31px 14px;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
  }
}

@media (max-width: 1400px) {
  .bingoLogoBoxNumber {
    max-height: 130px;
    min-height: 130px;
  }

  .ticketCard {
    height: 130px;
  }

  .colorBox {
    padding: 12px 18px;
  }

  .bingoLogoCard {
    height: 130px;
  }

  .bingoLogoCard img {
    width: 110px;
  }

  .ordinalSpanNumber {
    font-size: 40px;
  }

  .one-line-jackpot {
    padding: 12px 19px;
  }

  .ticketTitle {
    font-size: 24px;
    margin-bottom: 4px;
  }

  .numberSpan {
    line-height: 30px;
  }
}

@media (max-width: 1270px) {
  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
  }

  .progressOneLine {
    width: 70%;
    height: 5px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 58px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    max-width: 100px !important;
  }

  .gapBox {
    gap: 0px;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 207px;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 53px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }
}

@media (max-width: 1281px) {
  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .one-line {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    min-height: 17vh;
    max-height: 17vh;
    padding-top: 3px !important;
  }

  .progressOneLineJackpot {
    margin-top: 7px;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 19px !important;
    min-height: 18vh;
    max-height: 18vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    align-items: center;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .disable-div-number-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
  }

  .progressOneLine {
    width: 70%;
    height: 9px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }

  .progressOneLineJackpot {
    width: 70%;
    height: 9px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }

  .barOneLine {
    position: relative;
    float: left;
    min-width: 1%;
    height: 100%;
    border-radius: 6px;
    background: #990707;
  }

  .barTwoLine {
    position: relative;
    float: left;
    min-width: 1%;
    height: 100%;
    border-radius: 6px;
    background: #0729a0;
  }

  .barTwoLineJackpot {
    position: relative;
    float: left;
    min-width: 1%;
    height: 100%;
    border-radius: 6px;
    background: #efa602;
  }

  .barThreeLine {
    position: relative;
    float: left;
    min-width: 1%;
    height: 100%;
    border-radius: 6px;
    background: #207818;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 50px;
    transform: translateY(-50%);
  }

  .absolute-center-right-jackpot {
    position: absolute;
    top: 50%;
    right: 0;
    width: 50px;
    transform: translateY(-50%);
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 139px;
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-center-right-number-jackpot {
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 72px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 22px;
  }

  .disable-div {
    color: rgba(255, 255, 255, 0.38) !important;
  }

  .ladbrokes_card {
    background-image: url(/img/background-image.068b2b5e.svg);
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    min-height: 100vh;
    padding: 0px 5px 1px 5px !important;
  }

  .successModal {
    border-radius: 39px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset !important;
    backdrop-filter: blur(50.266666412353516px) !important;
    color: rgba(0, 0, 0, 0.87);
    height: 245px;
    position: relative;
  }

  .successImg {
    position: absolute;
    top: -75px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 160px;
  }

  .text-h6-end {
    color: #fff;

    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
    line-height: 59px;
    padding-top: 80px;
  }

  .endGameModal .v-dialog {
    max-width: 500px !important;
  }

  .coin-width {
    width: 20px;
  }

  .ticketCard {
    height: 100px;
  }

  .colorBox {
    padding: 8px 18px;
  }

  .bingoLogoBoxNumber {
    max-height: 100px;
    min-height: 100px;
  }

  .ticketTitle {
    font-size: 18px;
  }

  .colorTitle {
    font-size: 22px;
  }

  .bingoLogoCard img {
    width: 80px;
  }

  .bingoLogoCard {
    height: 100px;
  }

  .oneLinediv {
    margin-top: 8px !important;
  }

  .ticketCard {
    margin-top: 7px;
  }
}

@media (min-width: 1300px) and (max-width: 1472px) {
  .oneLinediv {
    margin-top: 8px !important;
  }

  .oneLineSpanJackpot {
    font-size: 17px;
  }

  .oneLinedivJackpot {
    font-size: 26px;
  }

  .bingoLogoBoxNumber {
    max-height: 130px;
    min-height: 130px;
  }

  .ticketCard {
    margin-top: 8px;
    height: 130px;
  }

  .colorBox {
    padding: 12px 18px;
  }

  .bingoLogoCard {
    height: 130px;
  }

  .bingoLogoCard img {
    width: 110px;
  }

  .ordinalSpanNumber {
    font-size: 40px;
  }

  .one-line-jackpot {
    padding: 12px 19px;
  }

  .ticketTitle {
    font-size: 24px;
    margin-bottom: 4px;
  }

  .numberSpan {
    line-height: 30px;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 61px;
    transform: translateY(-50%);
  }
}

@media (min-width: 2100px) and (max-width: 2540px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 120px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 60px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 75px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 500px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 323px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 225px !important;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 55px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 134px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 49px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 118px;
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 130px;
    font-style: normal;
    font-weight: 400;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 18px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 32vh; */
    max-width: 24%;
  }
}

@media (min-width: 2541px) and (max-width: 2800px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 120px;
    transform: translateY(-50%);
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 75px;
    font-style: normal;
    font-weight: 400;
  }

  .disable-div-number-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 143px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 60px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 110px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 536px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 323px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 260px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 55px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 134px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 49px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 118px;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: -39px;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 190px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 30px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    /* min-height: 32vh; */
    max-width: 24%;
  }

  .absolute-center-right-jackpot {
    position: absolute;
    top: 50%;
    right: 0;
    width: 186px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number-jackpot {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 86px;
    font-style: normal;
    font-weight: 400;
  }

  .successImg {
    position: absolute;
    top: -75px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 220px;
  }

  .successModal {
    border-radius: 39px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset !important;
    -webkit-backdrop-filter: blur(50.266666412353516px) !important;
    backdrop-filter: blur(50.266666412353516px) !important;
    color: rgba(0, 0, 0, 0.87);
    height: 405px;
    position: relative;
  }

  .text-h6-end {
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 74px;
    font-style: normal;
    font-weight: 400;
    line-height: 77px;
    padding-top: 158px;
  }

  .coin-width {
    width: 90px;
  }

  .progressOneLineJackpot {
    width: 70%;
    height: 17px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }
}

@media (min-width: 1400px) and (max-width: 1680px) {
  .bingoLogoCard {
    height: 110px;
  }

  .bingoLogoCard img {
    width: 80px;
  }

  .bingoLogoBoxNumber {
    max-height: 110px;
    min-height: 110px;
  }

  .ticketCard {
    height: 110px;
  }

  .colorBox {
    padding: 8px 18px;
  }

  .one-line,
  .one-line-jackpot {
    min-height: 17vh;
    max-height: 17vh;
  }

  .oneLinedivJackpot {
    font-size: 26px;
  }

  .ticketTitle {
    font-size: 22px;
  }

  .colorTitle {
    font-size: 28px;
  }

  .absolute-center-right-jackpot {
    width: 60px;
  }

  .coin-width {
    width: 18px;
  }
}

@media (min-width: 1700px) and (max-width: 1880px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 88px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 360px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 260px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 190px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 88px;
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 90px;
    font-style: normal;
    font-weight: 400;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    /* min-height: 30vh; */
    max-width: 24%;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 12px 0px 8px 16px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .one-line {
    min-height: 18vh;
    max-height: 18vh;
  }

  /* nsjdjdd */

  .oneLinedivJackpot {
    font-size: 45px;
  }

  .oneLineSpanJackpot {
    font-size: 30px;
  }

  .oneLinediv {
    font-size: 45px;
  }

  .oneLineSpan {
    font-size: 30px;
  }

  .absolute-center-right {
    width: 80px;
  }

  .absolute-center-right-jackpot {
    width: 90px;
  }

  .bingoLogoBoxNumber {
    min-height: 140px;
    max-height: 140px;
  }

  .bingoLogoCard {
    height: 140px;
  }

  .bingoLogoCard img {
    width: 100px;
  }

  .ticketCard {
    height: 140px;
  }

  .colorBox {
    padding: 12px 18px;
  }
}

@media (min-width: 1900px) and (max-width: 2098px) {
  .one-line {
    min-height: 18vh;
    max-height: 18vh;
  }

  .absolute-center-right-jackpot {
    position: absolute;
    top: 50%;
    right: 0;
    width: 125px;
    transform: translateY(-50%);
  }

  .coin-width {
    width: 57px;
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 55px;
    font-style: normal;
    font-weight: 400;
  }

  .disable-div-number-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 80px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .absolute-center-right-number-jackpot {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 61px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 90px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 56px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 360px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 260px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 190px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 88px;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: -16px;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 120px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    /* min-height: 30vh; */
    max-width: 24%;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 25px !important;
    min-height: 18vh;
    max-height: 18vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .bingoLogoBoxNumber {
    min-height: 170px;
    max-height: 170px;
  }

  .bingoLogoCard {
    height: 170px;
  }

  .bingoLogoCard img {
    width: 130px;
  }

  .ticketCard {
    height: 170px;
  }

  .numberSpan {
    font-size: 32px;
  }

  .absolute-center-right-jackpot {
    width: 95px;
  }

  .absolute-center-right-number-jackpot {
    font-size: 56px;
  }
}

@media screen and (min-width: 2100px) and (max-width: 2300px) {
  .ticketCard {
    margin-top: -10px;
  }

  .bingoLogoCard {
    height: 160px;
  }

  .bingoLogoCard img {
    width: 120px;
  }

  .bingoLogoBoxNumber {
    max-height: 160px;
    min-height: 160px;
  }

  .ticketCard {
    height: 160px;
  }

  .absolute-center-right {
    width: 100px;
  }
}

@media screen and (min-width: 2302px) and (max-width: 3692px) {
  .ticketCard {
    margin-top: 10px;
  }

  .bingoLogoCard {
    height: 190px;
  }

  .bingoLogoCard img {
    width: 140px;
  }

  .bingoLogoBoxNumber {
    max-height: 190px;
    min-height: 190px;
  }

  .ticketCard {
    height: 190px;
  }

  .absolute-center-right {
    width: 110px;
  }
}

@media screen and (min-width: 2100px) and (max-width: 3692px) {
  .one-line {
    min-height: 18vh;
    max-height: 18vh;
  }

  .one-line-jackpot {
    min-height: 18vh;
  }

  .oneLinedivJackpot {
    font-size: 56px;
  }

  .oneLineSpanJackpot {
    font-size: 32px;
  }

  .oneLinediv {
    font-size: 56px;
  }

  .oneLineSpan {
    font-size: 32px;
  }

  .numberSpan {
    font-size: 32px;
  }

  .absolute-center-right-number {
    font-size: 45px;
  }

  .absolute-center-right-jackpot {
    width: 100px;
  }

  .absolute-center-right-number-jackpot {
    font-size: 45px;
  }
}

@media (min-width: 3100px) and (max-width: 3690px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 178px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 90px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 77px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 180px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 675px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 490px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 390px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 100px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 225px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 76px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 150px;
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 180px;
    font-style: normal;
    font-weight: 400;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    /* min-height: 32vh; */
    max-width: 24%;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 25px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
}

@media (min-width: 3692px) and (max-width: 3850px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 178px;
    transform: translateY(-50%);
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 109px;
    font-style: normal;
    font-weight: 400;
  }

  .disable-div-number-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 221px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .successModal {
    border-radius: 39px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset !important;
    -webkit-backdrop-filter: blur(50.266666412353516px) !important;
    backdrop-filter: blur(50.266666412353516px) !important;
    color: rgba(0, 0, 0, 0.87);
    height: 610px;
    position: relative;
  }

  .successImg {
    position: absolute;
    top: -164px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 405px;
  }

  .text-h6-end {
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 98px;
    font-style: normal;
    font-weight: 400;
    line-height: 114px;
    padding-top: 275px;
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 90px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 55px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 120px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-center-right-jackpot {
    position: absolute;
    top: 50%;
    right: 0;
    width: 269px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number-jackpot {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 125px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 790px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 490px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 390px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 100px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 225px;
    font-style: normal;
    font-weight: 400;
  }

  .ticketCard {
    margin-top: 20px;
  }

  .lowerCards {
    max-height: 300px;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 76px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 150px;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: -63px;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 290px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    /* min-height: 32vh; */
    max-width: 24%;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 25px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .progressOneLineJackpot {
    width: 70%;
    height: 21px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }

  .coin-width {
    width: 100px;
  }

  .bingoLogoCard {
    height: 250px;
  }

  .bingoLogoBoxNumber {
    min-height: 250px;
    max-height: 250px;
  }

  .ticketCard {
    min-height: 250px;
    max-height: 250px;
  }
}

@media (min-width: 4850px) and (max-width: 5800px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 260px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 139px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 115px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 172px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 1000px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 720px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 520px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 139px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 219px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 111px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 245px;
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 242px;
    font-style: normal;
    font-weight: 400;
  }

  .progressOneLine {
    width: 70%;
    height: 20px;
    background: #a8a8a8;
    border-radius: 13px;
    margin-top: 20px;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 25px;
    min-height: 19vh;
  }

  .lowerCards {
    max-height: 400px;
  }

  .bingoLogoCard {
    height: 400px;
  }

  .bingoLogoCard img {
    width: 300px;
  }

  .bingoLogoBoxNumber {
    min-height: 400px;
    max-height: 400px;
  }

  .ticketCard {
    margin-top: 27px;
    min-height: 400px;
    max-height: 400px;
  }

  .numberSpan {
    font-size: 100px;
  }

  .ordinalSpanNumber {
    font-size: 140px;
  }

  .oneLineSpan {
    font-size: 100px;
  }

  .oneLinediv {
    font-size: 140px;
  }

  .ticketTitle {
    font-size: 80px;
  }

  .colorTitle {
    font-size: 80px;
  }

  .colorBox {
    padding: 40px 100px;
  }
}

@media (min-width: 5900px) and (max-width: 7356px) {
  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 341px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 139px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 115px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 172px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 1000px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 720px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 520px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 139px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 219px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 111px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 245px;
  }

  .ordinal-span-number {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 242px;
    font-style: normal;
    font-weight: 400;
  }

  .progressOneLine {
    width: 70%;
    height: 20px;
    background: #a8a8a8;
    border-radius: 13px;
    margin-top: 20px;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 25px;
    min-height: 19vh;
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 228px;
    font-style: normal;
    font-weight: 400;
  }
}

@media (min-width: 7380px) and (max-width: 7700px) {
  .one-line {
    min-height: 20vh;
    max-height: 20vh;
  }

  .absolute-center-right {
    position: absolute;
    top: 50%;
    right: 0;
    width: 400px;
    transform: translateY(-50%);
  }

  .disable-div-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 228px;
    font-style: normal;
    font-weight: 400;
  }

  .disable-div-number-jackpot {
    color: rgba(255, 255, 255, 0.38) !important;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 460px;
    font-style: normal;
    font-weight: 500;
    text-align: left;
  }

  .absolute-center-right-number {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 235px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLineSpan {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 125px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinediv {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 250px;
    font-style: normal;
    font-weight: 400;
  }

  .absolute-bottom-center {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 1585px;
    transform: translateX(-50%);
  }

  .bingoLogoBox img {
    width: 1100px;
  }

  .absolute-center-top {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 850px;
  }

  .oneLineSpanJackpot {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 205px;
    font-style: normal;
    font-weight: 400;
  }

  .oneLinedivJackpot {
    color: #efa602;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 430px;
    font-style: normal;
    font-weight: 400;
  }

  .ordinal-span {
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 145px;
    font-style: normal;
    font-weight: 400;
  }

  .value-text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
    z-index: 9999;
    gap: 410px;
  }

  .ordinal-span-number {
    color: #fff;
    position: absolute;
    bottom: -87px;
    left: 50%;
    transform: translateX(-50%);
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 550px;
    font-style: normal;
    font-weight: 400;
    z-index: 11111;
  }

  .progressOneLine {
    width: 70%;
    height: 38px;
    background: #a8a8a8;
    border-radius: 13px;
    margin-top: 20px;
  }

  .one-line-jackpot {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    position: relative;
    padding: 39px !important;
    min-height: 19vh;
    max-width: 100% !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }

  .bingoLogoBox {
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 32px;
    /* min-height: 33vh; */
    max-width: 24%;
  }

  .successModal {
    border-radius: 39px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset !important;
    -webkit-backdrop-filter: blur(50.266666412353516px) !important;
    backdrop-filter: blur(50.266666412353516px) !important;
    color: rgba(0, 0, 0, 0.87);
    height: 900px;
    position: relative;
  }

  .successImg {
    position: absolute;
    top: -234px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 560px;
  }

  .text-h6-end {
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 136px;
    font-style: normal;
    font-weight: 400;
    line-height: 167px;
    padding-top: 380px;
  }

  .progressOneLineJackpot {
    width: 65%;
    height: 51px;
    background: #a8a8a8;
    border-radius: 6px;
    margin-top: 12px;
  }

  .coin-width {
    width: 200px;
  }

  .absolute-center-right-jackpot {
    position: absolute;
    top: 50%;
    right: 0;
    width: 400px;
    transform: translateY(-50%);
  }

  .absolute-center-right-number-jackpot {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    color: #fff;
    font-family: "Arial Rounded MT Bold", Arial, sans-serif;
    font-size: 287px;
    font-style: normal;
    font-weight: 400;
  }

  .lowerCards {
    max-height: 500px;
  }

  .bingoLogoCard {
    height: 500px;
  }

  .bingoLogoCard img {
    width: 350px;
  }

  .bingoLogoBoxNumber {
    min-height: 500px;
    max-height: 500px;
  }

  .ticketCard {
    margin-top: 30px;
    min-height: 500px;
    max-height: 500px;
  }

  .ticketTitle {
    font-size: 120px;
  }

  .colorTitle {
    font-size: 120px;
  }

  .colorBox {
    padding: 40px 12px;
  }

  .numberSpan {
    font-size: 100px;
  }

  .ordinalSpanNumber {
    font-size: 200px;
  }
}
</style>
<style>
.v-dialog {
  border-radius: 4px;
  margin: 24px;
  overflow-y: visible !important;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  max-width: 610px;
}

@media (min-width: 3692px) and (max-width: 3850px) {
  .v-dialog {
    border-radius: 4px;
    margin: 24px;
    overflow-y: visible !important;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    max-width: 1200px;
  }
}

@media (min-width: 7380px) and (max-width: 7700px) {
  .v-dialog {
    border-radius: 4px;
    margin: 24px;
    overflow-y: visible !important;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    max-width: 1700px;
  }
}

@media (min-width: 2541px) and (max-width: 2800px) {
  .v-dialog {
    border-radius: 4px;
    margin: 24px;
    overflow-y: visible !important;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    max-width: 880px;
  }
}
</style>
